import SettingsOutlined from '@icons/SettingsOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';
import SettingsPopover from './SettingsPopover';

const SettingsButton = () => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      setAnchor(e.currentTarget);
    },
    [setAnchor]
  );
  const onClose = useCallback(() => {
    setAnchor(null);
  }, [setAnchor]);
  return (
    <>
      <Tooltip title="Settings">
        <IconButton color={!!anchor ? 'primary' : 'default'} onClick={onClick}>
          <SettingsOutlined />
        </IconButton>
      </Tooltip>
      <SettingsPopover anchor={anchor} onClose={onClose} />
    </>
  );
};
export default SettingsButton;
